import { useEffect, useState } from "react";
import { MessageCircle } from "lucide-react";
import { CONTACT, decodeContact } from "@/lib/contactProtect";

/**
 * WhatsApp butonu. Numara kodlanmış tutulur ve yalnızca tarayıcıda çözülür,
 * böylece wa.me linki prerender edilmiş statik HTML'de görünmez.
 * Bkz. lib/contactProtect.ts.
 */
export default function WhatsAppButton() {
  const [href, setHref] = useState<string | null>(null);

  useEffect(() => {
    const number = decodeContact(CONTACT.whatsappNumber);
    if (number) setHref(`https://wa.me/${number}`);
  }, []);

  const className =
    "fixed bottom-6 right-6 z-50 bg-[#25D366] text-white p-4 rounded-full shadow-lg hover:scale-110 transition-transform duration-300";

  // Numara çözülene kadar bağlantı yerine iletişim formuna yönlendir.
  if (!href) {
    return (
      <a href="/contact" className={className} aria-label="Contact us">
        <MessageCircle className="w-6 h-6" />
      </a>
    );
  }

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className={className}
      aria-label="Contact us on WhatsApp"
    >
      <MessageCircle className="w-6 h-6" />
    </a>
  );
}
